var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 26,
    viewBox: "0 0 21 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.9167 0H2.58333C1.1625 0 0 1.1625 0 2.58333V23.25C0 24.6708 1.1625 25.8333 2.58333 25.8333H18.0833C19.5042 25.8333 20.6667 24.6708 20.6667 23.25V7.75L12.9167 0ZM18.0833 23.25H2.58333V2.58333H12.9167V7.75H18.0833V23.25ZM10.3333 19.375C8.9125 19.375 7.75 18.2125 7.75 16.7917V9.6875C7.75 9.32583 8.03417 9.04167 8.39583 9.04167C8.7575 9.04167 9.04167 9.32583 9.04167 9.6875V16.7917H11.625V9.6875C11.625 7.905 10.1783 6.45833 8.39583 6.45833C6.61333 6.45833 5.16667 7.905 5.16667 9.6875V16.7917C5.16667 19.6463 7.47875 21.9583 10.3333 21.9583C13.1879 21.9583 15.5 19.6463 15.5 16.7917V11.625H12.9167V16.7917C12.9167 18.2125 11.7542 19.375 10.3333 19.375Z",
    fill: "#5D5D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.23f98f7f0624a64c06f4c953a7c8a3ba.svg";
export { ForwardRef as ReactComponent };